/**
 * Centralized API base URL and fetch with timeout.
 * Socket can use same origin (legacy) or separate REACT_APP_SOCKET_URL when socket-service runs alone.
 */

const DEFAULT_TIMEOUT_MS = 15000;

export function getApiBaseUrl() {
  const url = process.env.REACT_APP_URL;
  if (!url) {
    console.warn("REACT_APP_URL is not set");
    return "";
  }
  return url.replace(/\/$/, "");
}

/** Base URL for Socket.IO. Uses REACT_APP_SOCKET_URL, or fallback when API روی localhost است به پورت socket. */
export function getSocketBaseUrl() {
  const url = process.env.REACT_APP_SOCKET_URL;
  if (url) return url.replace(/\/$/, "");
  const apiBase = getApiBaseUrl();
  try {
    const u = new URL(apiBase);
    if (u.hostname === "localhost" || u.hostname === "127.0.0.1") {
      if (u.port === "8080") return "http://localhost:8081";
      if (u.port === "9080") return "http://localhost:9081";
    }
  } catch (_) {}
  return apiBase;
}

export function getSocketPath() {
  return process.env.REACT_APP_SOCKET_PATH || "/socket.io";
}

/**
 * Fetch with base URL and timeout. Avoids pending requests hanging forever.
 * @param {string} path - API path (e.g. "/api/getallcurrencies")
 * @param {RequestInit & { timeout?: number }} options - fetch options; timeout in ms (default 15000)
 * @returns {Promise<Response>}
 */
export async function apiFetch(path, options = {}) {
  const base = getApiBaseUrl();
  const url = path.startsWith("http") ? path : `${base}${path}`;
  const timeoutMs = options.timeout ?? DEFAULT_TIMEOUT_MS;

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const res = await fetch(url, {
      ...options,
      signal: controller.signal,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
    clearTimeout(timeoutId);
    return res;
  } catch (err) {
    clearTimeout(timeoutId);
    if (err.name === "AbortError") {
      throw new Error(`Request timeout after ${timeoutMs}ms`);
    }
    throw err;
  }
}
